import React, {useState} from "react";
import Icon from "../../ui/Icon";
import Button from "../button/Button";

const PasswordInput = ({
                           name,
                           value,
                           error,
                           label,
                           onChange,
                           onBlur,
                           columns,
                           inline,
                       }) => {
    const [showPassword, setShowPassword] = useState(false);

    const className = `${inline ? "d-flex flex-wrap" : ""} col-12${
        columns?.md ? " col-md-" + columns.md : ""
    }`;

    return (
        <div className={className}>
            {label && (
                <label
                    className={`form-label opacity-75${
                        inline ? " mb-0 py-2 col-12 col-md-4" : ""
                    }`}
                    htmlFor={name}
                >
                    {label}
                </label>
            )}

            <div className={`input-group position-relative${inline ? " col" : ""}`}>
                <input
                    type={showPassword ? "text" : "password"}
                    className="form-control rounded-2"
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    id={name}
                    style={{paddingRight: 40}}
                />
                <Button
                    type="button"
                    className="bg-transparent position-absolute end-0 h-100 z-max"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                >
                    {showPassword ? (
                        <Icon width="18" height="18" name="visibilityOff"/>
                    ) : (
                        <Icon width="18" height="18" name="visibility"/>
                    )}
                </Button>
            </div>

            {error && (
                <div
                    className={`form-text text-start text-danger w-100${
                        inline && label ? " offset-4" : ""
                    }`}
                >
                    {error}
                </div>
            )}
        </div>
    );
};

export default PasswordInput;
